export default __webpack_public_path__ + "static/workstation-a1bab5e7fb284c469f090b10eabdde6b.png";